var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectdislike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3903 4.73828L10.0653 2.93828C9.76529 2.63828 9.09029 2.48828 8.64029 2.48828H5.79029C4.89029 2.48828 3.91529 3.16328 3.69029 4.06328L1.89029 9.53828C1.51529 10.5883 2.19029 11.4883 3.31529 11.4883H6.31529C6.76529 11.4883 7.14029 11.8633 7.06529 12.3883L6.69029 14.7883C6.54029 15.4633 6.99029 16.2133 7.66529 16.4383C8.26529 16.6633 9.01529 16.3633 9.31529 15.9133L12.3903 11.3383",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2148 4.7375V12.0875C16.2148 13.1375 15.7648 13.5125 14.7148 13.5125H13.9648C12.9148 13.5125 12.4648 13.1375 12.4648 12.0875V4.7375C12.4648 3.6875 12.9148 3.3125 13.9648 3.3125H14.7148C15.7648 3.3125 16.2148 3.6875 16.2148 4.7375Z",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectdislike);
export default __webpack_public_path__ + "static/media/projectdislike.7a1c8d3a566b3dc93dd8f0734531d2f8.svg";
export { ForwardRef as ReactComponent };